import { Button } from '@mui/material';
import { useState } from 'react';
import Iconify from 'src/components/iconify';
import TrackApplicationsDialog from './dialog';

export default function TrackYourApplications() {
  // states
  const [openTrackYourApplicationsDialog, setOpenTrackYourApplicationsDialog] =
    useState(false);

  return (
    <>
      <Button
        startIcon={<Iconify icon="tabler:plus" />}
        sx={{
          color: 'background.primaryAccent1',
          width: '210px',
        }}
        onClick={() => {
          setOpenTrackYourApplicationsDialog(true);
        }}
      >
        Get source tracking code
      </Button>
      <TrackApplicationsDialog
        open={openTrackYourApplicationsDialog}
        setOpen={setOpenTrackYourApplicationsDialog}
      />
    </>
  );
}
